import React, { useState, useEffect } from "react";
import ReplyIcon from "@material-ui/icons/Reply";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOffAltOutlinedIcon from "@mui/icons-material/ThumbDownOffAltOutlined";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import { styled } from "@mui/system";
import { format } from "timeago.js";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const Answer = ({ ans, question }) => {
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const [error, setError] = useState("");
  const [reply, setReply] = useState("");
  const [replies, setReplies] = useState([]);
  const [showReplies, setShowReplies] = useState(false);
  const navigate = useNavigate();
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [isDisliked, setIsDisliked] = useState(false);
  const [dislikeCount, setDislikeCount] = useState(0);
  const [uploader, setUploader] = useState("");
  useEffect(() => {
    ans?.user &&
      api
        .get(`/user/getUserdataById/` + ans?.userId)
        .then((res) => {
          // console.log("user", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [ans]);

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  useEffect(() => {
    console.log(currentUser?.id, question?.userId);
  }, []);

  useEffect(() => {
    api
      .get(`/questions/replies-of-particular-answer/${ans?._id}`)
      .then((res) => {
        console.log("replies respnse", res.data);
        setReplies(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const submitReply = (e) => {
    e.preventDefault();
    setReply("");
    if (!reply) {
      setError("required");
    }
    // else if (reply.length < 30) {
    //   setError("your reply should be 30 chrachters long atleast.");
    // }
    else {
      console.log("answer", ans);
      console.log("reply", reply);
      const body = {
        userId: currentUser.id,
        user: currentUser,
        answerId: ans?._id,
        reply: reply,
      };
      api
        .post("/questions/reply-the-answer", body)
        .then((res) => {
          if (res.data) {
            let notifBody = {
              userId: currentUser?.id,
              text: `${currentUser?.name} replies your answer.`,
              forAll: false,
              receiverId: ans?.userId,
            };
            api
              .post("/notifications", notifBody)
              .then((re) => console.log("notif", re.data));
            // window.location.reload();
            setReplies([...replies, res.data]);
          }
        })
        .catch((err) => console.log(err));
    }
  };
  /************ */
  useEffect(() => {
    console.log("question", ans);
    let temp = false;
    ans?.likerIds?.map((id) => {
      if (id == currentUser?.id) {
        temp = true;
      }
    });
    setIsLiked(temp);
    setLikeCount(ans?.likerIds?.length > 0 ? ans?.likerIds?.length : 0);
    /******** */
    let temp2 = false;
    ans?.dislikerIds?.map((id) => {
      if (id == currentUser?.id) {
        temp2 = true;
      }
    });
    setIsDisliked(temp2);
    setDislikeCount(
      ans?.dislikerIds?.length > 0 ? ans?.dislikerIds?.length : 0
    );
  }, [ans]);
  const likeAnswer = () => {
    if (isDisliked) {
      setIsDisliked(false);
      let x = dislikeCount - 1;
      setDislikeCount(x);
      dislikeAnswerUndo();
    }
    setIsLiked(true);
    let x = likeCount + 1;
    setLikeCount(x);

    api
      .post(
        `/questions/like-answer/${ans?.id ? ans?.id : ans?._id}/${
          currentUser?.id
        }`
      )
      .then((res) => {
        console.log("response data of like question", res?.data);
      })
      .catch((err) => console.log("error while liking question", err));
  };
  const likeAnswerUndo = () => {
    setIsLiked(false);
    let x = likeCount - 1;
    setLikeCount(x);
    api
      .post(
        `/questions/like-answer-undo/${ans?.id ? ans?.id : ans?._id}/${
          currentUser?.id
        }`
      )
      .then((res) => {
        console.log("response data of undo like question", res?.data);
      })
      .catch((err) => console.log("error while liking question", err));
  };

  const dislikeAnswer = () => {
    if (isLiked) {
      setIsLiked(false);
      let x = likeCount - 1;
      setLikeCount(x);
      likeAnswerUndo();
    }
    setIsDisliked(true);
    let x = dislikeCount + 1;
    setDislikeCount(x);

    api
      .post(
        `/questions/dislike-answer/${ans?.id ? ans?.id : ans?._id}/${
          currentUser?.id
        }`
      )
      .then((res) => {
        console.log("response data of like question", res?.data);
      })
      .catch((err) => console.log("error while liking question", err));
  };
  const dislikeAnswerUndo = () => {
    setIsDisliked(false);
    let x = dislikeCount - 1;
    setDislikeCount(x);
    api
      .post(
        `/questions/dislike-answer-undo/${ans?.id ? ans?.id : ans?._id}/${
          currentUser?.id
        }`
      )
      .then((res) => {
        console.log("response data of undo like question", res?.data);
      })
      .catch((err) => console.log("error while liking question", err));
  };
  const deleteAnswer = () => {
    api
      .delete(`/questions/answer/${ans?.id ? ans?.id : ans?._id}`)
      .then((res) => {
        console.log("response data of undo like question", res?.data);
        window.location.reload();
      })
      .catch((err) => console.log("error while deleting question", err));
  };
  return (
    <>
      <Card
        sx={{
          width: "90%",
          position: "relative",
          marginBottom: "20px",
          boxShadow: "none",
          borderBottom: "1px solid lightgray",
        }}
      >
        <CardHeader
          avatar={
            <Stack direction="column">
              {uploader?.profile ? (
                <Avatar
                  src={uploader?.profile}
                  sx={{ bgcolor: "colorThree.main" }}
                />
              ) : (
                <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                  {ans?.user?.name?.at(0)?.toUpperCase()}
                </Avatar>
              )}
            </Stack>
          }
          // action={
          //   <IconButton aria-label="settings">
          //     <MoreVertIcon />
          //   </IconButton>
          // }
          title={ans?.user?.name + "   "}
          // subheader={new Date(ans?.createdAt).toDateString()}
          subheader={format(ans?.createdAt)}
          // subheader={ans?.answer}
        />
        {/* <CardMedia
        component="img"
        height="194"
        image="/static/images/cards/paella.jpg"
        alt="Paella dish"
      /> */}
        <CardContent>
          <Typography
            sx={{
              fontSize: "1rem",
              marginBottom: "10px",
              marginTop: "-10px",
              fontWeight: "500",
              marginLeft: "56px",
            }}
            color="fontPrimaryColor.main"
            variant="body2"
          >
            {ans?.answer}
          </Typography>
        </CardContent>
        <CardActions
          disableSpacing
          sx={{ marginTop: "10px", marginLeft: "auto", width: "90%" }}
        >
          {/* <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton> */}
          <Stack
            direction="column"
            sx={{ width: "50px", alignItems: "center" }}
          >
            {isLiked ? (
              <IconButton onClick={() => likeAnswerUndo()}>
                <ThumbUpIcon />
              </IconButton>
            ) : (
              <IconButton onClick={() => likeAnswer()}>
                <ThumbUpOutlinedIcon />
              </IconButton>
            )}

            <Typography sx={{ fontSize: "10px" }}>{likeCount}</Typography>
          </Stack>
          <Stack
            direction="column"
            sx={{ width: "50px", alignItems: "center" }}
          >
            {isDisliked ? (
              <IconButton onClick={() => dislikeAnswerUndo()}>
                <ThumbDownIcon />
              </IconButton>
            ) : (
              <IconButton onClick={() => dislikeAnswer()}>
                <ThumbDownOffAltOutlinedIcon />
              </IconButton>
            )}

            <Typography sx={{ fontSize: "10px" }}>{dislikeCount}</Typography>
          </Stack>
          {(question?.userId == currentUser?.id || currentUser?.isAdmin) && (
            <IconButton onClick={() => deleteAnswer(ans)}>
              <DeleteOutlineIcon sx={{ color: "#cc0000" }} />
            </IconButton>
          )}
          {/* <Stack
            direction="column"
            sx={{ width: "80px", alignItems: "center" }}
          >
            <IconButton
              onClick={() => navigate(`/newsfeed/answers/${question._id}`)}
            >
              <QuestionAnswerOutlinedIcon />
            </IconButton> 
            <Typography sx={{ fontSize: "10px" }}>12 answers</Typography>
          </Stack> */}
          {/* <Button
            sx={{
              marginLeft: "20px",
              marginRight: "15px",
              backgroundColor: "colorTwo.main",
              fontSize: "0.8rem",
            }}
            variant="contained"
            className="answers-status-btn  answer-btn"
            // className=" reply__btn"
            data-bs-toggle="modal"
            data-bs-target="#replyModal"
          >
            Reply
          </Button> */}

          <Typography
            sx={{
              marginLeft: "auto",
              position: "absolute",
              bottom: "20",
              right: "50px",
              color: "gray",
              fontSize: "0.8rem",
            }}
          >
            replies
          </Typography>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </ExpandMore>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Stack
              direction="row"
              sx={{ gap: "3px", marginLeft: "auto" }}
              width="90%"
            >
              {currentUser?.profile ? (
                <Avatar src={currentUser?.profile} />
              ) : (
                <Avatar>{currentUser?.name[0]}</Avatar>
              )}
              <input
                type="text"
                style={{ flex: "1" }}
                className="submit__ans__input__field"
                placeholder="write your reply here..."
                onChange={(e) => setReply(e.target.value)}
                value={reply}
              ></input>

              <button
                className="asc__submit__form__button "
                onClick={(e) => submitReply(e)}
              >
                Add Reply
              </button>
            </Stack>
            {error && <p className="error__para">{error}</p>}
            <Box className="replies__container pl-5 mt-3">
              {!replies?.length > 0 ? (
                <Typography variant="body2" sx={{ marginLeft: "55px" }}>
                  no replies
                </Typography>
              ) : (
                replies
                  ?.sort(function (a, b) {
                    return new Date(b.updatedAt) - new Date(a.updatedAt);
                  })
                  ?.map((r) => (
                    // <Box className="reply row border-top border-gray   pb-3 pl-9">
                    //   <Box className="col-lg-6 col-md-6 col-12">
                    //     <p className="title">
                    //       <strong>{r.user.name}</strong>
                    //     </p>
                    //   </Box>
                    //   <Box className="col-lg-6 col-md-6 col-12">
                    //     <p>
                    //       Posted:{" "}
                    //       <strong className="date">
                    //         {new Date(r?.createdAt).toDateString()}
                    //       </strong>
                    //     </p>
                    //   </Box>

                    //   <Box className="desc">
                    //     <p>{r.reply}</p>
                    //   </Box>
                    // </Box>
                    <Reply r={r} />
                  ))
              )}
            </Box>
          </CardContent>
        </Collapse>
      </Card>
      {/* <Box className="row border-bottom border-dark pb-3">
        <Box className="col-lg-6 col-md-6 col-12">
          <h6 className="title">
            <strong>{ans.user.name}</strong>
          </h6>
        </Box>
        <Box className="col-lg-6 col-md-6 col-12">
          <p>
            Posted:{" "}
            <strong className="date">
              {new Date(ans?.createdAt).toDateString()}
            </strong>
          </p>
        </Box>

        <Box className="desc">
          <p>{ans.answer}</p>
        </Box>
        <button
          className="view__reply__btn"
          onClick={() => setShowReplies(!showReplies)}
        >
          {!showReplies ? <VisibilityIcon /> : <VisibilityOffIcon />}
         
          Replies ({replies?.length})
        </button>
        <button
          className=" reply__btn"
          data-bs-toggle="modal"
          data-bs-target="#replyModal"
        >
          <ReplyIcon />
          Reply
        </button>

        {showReplies && (
          <Box className="replies__container pl-5 mt-3">
       
            {replies.map((r) => (
              <Box className="reply row border-top border-gray   pb-3 pl-9">
                <Box className="col-lg-6 col-md-6 col-12">
                  <p className="title">
                    <strong>{r.user.name}</strong>
                  </p>
                </Box>
                <Box className="col-lg-6 col-md-6 col-12">
                  <p>
                    Posted:{" "}
                    <strong className="date">
                      {new Date(r?.createdAt).toDateString()}
                    </strong>
                  </p>
                </Box>

                <Box className="desc">
                  <p>{r.reply}</p>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Box> */}
      <Box
        className="modal fade answer__question__modal"
        id="replyModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <Box className="modal-dialog answer__question__modal">
          <Box className="modal-content answer__question__modal">
            <Box className="modal-header">
              <Typography
                variant="h5"
                className="modal-title"
                id="replyModalLabel"
              >
                Write your Reply
              </Typography>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </Box>

            <Box className="form">
              <Box>
                <Box className="modal-body">
                  <textarea
                    className="form-control input__field__asc"
                    name="reply"
                    id="reply"
                    placeholder="reply"
                    onChange={(e) => setReply(e.target.value)}
                  />
                  {error && <p className="error__para">{error}</p>}
                </Box>

                <Box className="modal-footer">
                  <button
                    className="asc__submit__form__button btn-primary"
                    onClick={(e) => submitReply(e)}
                  >
                    Submit Answer
                  </button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Answer;

const Reply = ({ r }) => {
  const [uploader, setUploader] = useState("");

  useEffect(() => {
    r?.userId &&
      api
        .get(`/user/getUserdataById/` + r?.userId)
        .then((res) => {
          console.log("userrrrrrrrrrrrrr", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [r]);
  return (
    <Card
      sx={{
        width: { xs: "100%", sm: "90%" },
        marginLeft: "auto",
        boxShadow: "none",
        borderBottom: "1px solid lightgray",
      }}
    >
      <CardHeader
        avatar={
          <Stack direction="column">
            {uploader?.profile ? (
              <Avatar
                src={uploader?.profile}
                sx={{ bgcolor: "colorThree.main" }}
              />
            ) : (
              <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                {r?.user?.name?.at(0)?.toUpperCase()}
              </Avatar>
            )}
          </Stack>
        }
        // action={
        //   <IconButton aria-label="settings">
        //     <MoreVertIcon />
        //   </IconButton>
        // }
        title={`${r?.user?.name?.toUpperCase()}`}
        subheader={r?.reply}
      />
      <CardContent>
        <Typography variant="body2" sx={{ color: "gray" }}>
          {" "}
          {format(r?.createdAt)}
        </Typography>
      </CardContent>
    </Card>
  );
};
